export class Pipes {
  static snake2Normal = (str) => {
    return str.split("_").join(" ");
  };

  static normal2Snake = (str) => {
    return str.split(" ").join("_");
  };
}
